import React, { useMemo } from 'react';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import oneDark from 'react-syntax-highlighter/dist/esm/styles/prism/one-dark';
import csharp from 'react-syntax-highlighter/dist/esm/languages/prism/csharp';
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript';
import typescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript';
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json';
import markup from 'react-syntax-highlighter/dist/esm/languages/prism/markup';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
import yaml from 'react-syntax-highlighter/dist/esm/languages/prism/yaml';
import markdown from 'react-syntax-highlighter/dist/esm/languages/prism/markdown';

SyntaxHighlighter.registerLanguage('csharp', csharp);
SyntaxHighlighter.registerLanguage('javascript', javascript);
SyntaxHighlighter.registerLanguage('typescript', typescript);
SyntaxHighlighter.registerLanguage('json', json);
SyntaxHighlighter.registerLanguage('markup', markup); // xml/html
SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('yaml', yaml);
SyntaxHighlighter.registerLanguage('markdown', markdown);

type Props = {
  filename: string;
  content: string;
};

const detectLanguage = (filename: string): string => {
  const lower = (filename || '').toLowerCase();
  if (lower.endsWith('.cs')) return 'csharp';
  if (lower.endsWith('.ts') || lower.endsWith('.tsx')) return 'typescript';
  if (lower.endsWith('.js') || lower.endsWith('.jsx')) return 'javascript';
  if (lower.endsWith('.json')) return 'json';
  if (lower.endsWith('.xml') || lower.endsWith('.html')) return 'markup';
  if (lower.endsWith('.py')) return 'python';
  if (lower.endsWith('.yml') || lower.endsWith('.yaml')) return 'yaml';
  if (lower.endsWith('.md')) return 'markdown';
  return 'text';
};

const CodeViewer: React.FC<Props> = ({ filename, content }) => {
  const lang = useMemo(() => detectLanguage(filename), [filename]);
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2 small text-muted">
        <div>{filename}</div>
        <div>{lang}</div>
      </div>
      <SyntaxHighlighter
        language={lang}
        style={oneDark}
        wrapLongLines
        showLineNumbers
        customStyle={{ margin: 0, borderRadius: 8, fontSize: 12 }}
      >
        {content || ''}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeViewer;


